import { observer } from "mobx-react";
import RmaPageStore, {
	IRmaAction,
	IRmaApproveAction,
	IRmaMarkAsDoneAction,
	IRmaReceiveShipmentAction,
	RMA_ACTION_TYPE,
} from "../../stores/rma-page-store";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import managerApprovalModalStore from "../../../../../manager-approval-modal/manager-approval-modal-store";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

type NextPrimaryAction = IRmaApproveAction | IRmaReceiveShipmentAction | IRmaMarkAsDoneAction;

interface IProps {
    nextAction: NextPrimaryAction;
    rma: RmaPageStore;
    disabled: boolean;
    label: string;
    setCurrentRmaAction: (action: IRmaAction | null) => void;
}

const trackPrimaryClick = (actionType: RMA_ACTION_TYPE): void => {
	switch (actionType) {
		case RMA_ACTION_TYPE.APPROVE:
			rmsMixpanelStore.trackEvent("d&_approve_button");
			break;
		case RMA_ACTION_TYPE.RECEIVE_SHIPMENT:
			rmsMixpanelStore.trackEvent("d&_shipment_received_button");
			break;
		case RMA_ACTION_TYPE.MARK_AS_DONE:
			rmsMixpanelStore.trackEvent("d&_mark_as_done");
			break;
	}
};

const RmaNextPrimaryActionButton: React.FC<IProps> = observer(
    ({ nextAction, rma, disabled, label, setCurrentRmaAction }) => {
        const onClick = async () => {
            trackPrimaryClick(nextAction.type);

            if (nextAction.type === RMA_ACTION_TYPE.APPROVE && rma.shouldRequestManagersApproval()) {
                const credsResult = await managerApprovalModalStore.collectCredentials();
                if (!credsResult.credentials) {
                    return;
                }
                rma.setManagerCredentials(credsResult.credentials);
            }

            setCurrentRmaAction(nextAction);
        };

        return (
            <Button
                variant={BUTTON_VARIANTS.PrimaryAccent}
                text={label}
                disabled={nextAction.disabled || disabled}
                onClick={onClick}
            />
        );
    }
);

export default RmaNextPrimaryActionButton;
